import type { ValueOf } from 'type-fest';
import { _Column } from './column';

const _Encoding = {
  'utf-8': 'utf-8',
  shift_jis: 'shift_jis',
} as const;
type _Encoding = ValueOf<typeof _Encoding>;

const _Delimiter = {
  ',': ',',
  '\t': '\t',
  '|': '|',
} as const;
type _Delimiter = ValueOf<typeof _Delimiter>;

export namespace _SchemaJson {
  export import Column = _Column;

  export type Encoding = _Encoding;
  export namespace Encoding {
    export const FromString = (s: string): Encoding => {
      const value = _Encoding[s as keyof typeof _Encoding];
      if (!value) throw new Error(`Invalid ImportTableDefinition.Encoding: ${s}`);
      return value;
    };
  }

  export type Delimiter = _Delimiter;
  export namespace Delimiter {
    export const FromString = (s: string): Delimiter => {
      const value = _Delimiter[s as keyof typeof _Delimiter];
      if (!value) throw new Error(`Invalid ImportTableDefinition.Delimiter: ${s}`);
      return value;
    };
  }

  export type Props = {
    hasHeaderRow: boolean;
    encoding: string;
    delimiter: string;
    columns: Column.Props[];
  };
  export const Construct = (props: Props): _SchemaJson => ({
    hasHeaderRow: props.hasHeaderRow,
    encoding: Encoding.FromString(props.encoding),
    delimiter: Delimiter.FromString(props.delimiter),
    columns: props.columns.map(Column.Construct),
  });
}
export type _SchemaJson = {
  hasHeaderRow: boolean;
  encoding: _SchemaJson.Encoding;
  delimiter: _SchemaJson.Delimiter;
  columns: _SchemaJson.Column[];
};
